import { toPhone } from "common/utils/formatting";

import TextButton from "client/common/components/buttons/TextButton";
import { useSupportChat } from "client/support/hooks";
import { urls } from "client/routes";
import { AuthSearch } from "client/accounts/types";

import styles from "../../styles/ExistingAccountAlert.module.less";

type ExistingAccountAlertProps = {
  search: AuthSearch;
};

const ExistingAccountAlert = ({ search }: ExistingAccountAlertProps) => {
  const chat = useSupportChat();

  const username = search.phone ? toPhone(search.phone) : search.email;

  return (
    <div className={styles.content}>
      <div>
        <span className={styles.lead}>
          You already have a Home Delivery account for {username}.
        </span>{" "}
        If you previously signed up through another clinic, use the same password to log in here.
      </div>
      <div>
        Forgot your password?{" "}
        <TextButton hasUnderline={true} dest={urls.accounts.resetPassword({ search })}>
          Reset password
        </TextButton>
        .
      </div>
      <div>
        Need help accessing your account?{" "}
        <TextButton hasUnderline={true} onClick={() => chat.showNewMessage()}>
          Contact support
        </TextButton>
        .
      </div>
    </div>
  );
};

export default ExistingAccountAlert;
